import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Button from '../../Common/Button';
import MultiSelectBox from '../../Common/MultiSelectBox/MultiSelectBox';
import TextArea from '../../Common/TextArea';
import InputText from '../../Common/InputText';

export const UserProfileStep = (props) => {

    const onChange = (e) => {
        props.onFormChange(e.target.name, e.target.value);
    }

    const onMultiSelectChange = (value, name) => {
        props.onFormChange(name, value.toString());
    }

    const onManagementCompanyChange = (value, name) => {
        props.onManagementCompanyChange(name, value.toString());
    }

    const onEmailChange = (e) => {
        props.onEmailChange(e.target.value);
    }

    const onSubmit = (e) => {
        e.preventDefault();
        e.stopPropagation();

        if(props.showFullForm) {
            props.onSubmitRequest();
        } else {
            props.onContinue();
        }

        
    }

    const valid = props.isFormValid ? "" : "was-validated";
    const className = "user-profile-set-form " + valid;

    return (
        <form onSubmit={onSubmit} className={className} noValidate>

            <div className="row">
                <div className="col-12 col-sm-6">
                    <InputText name="firstName" isFocused={true} placeholder="First Name" type="text" value={props.userRequest.firstName} onChange={onChange} isRequired={true} errorMessage="First Name is required" />
                    <InputText name="lastName" placeholder="Last Name" type="text" value={props.userRequest.lastName} onChange={onChange} isRequired={true} errorMessage="Last Name is required" />
                </div>
                <div className="col-12 col-sm-6">
                    <InputText name="email" placeholder="Email" type="text" value={props.userRequest.email} onChange={onEmailChange} onBlur={props.onEmailBlur} isRequired={true} errorMessage="Email is required" />
                    <InputText name="userName" placeholder="UserName" type="text" value={props.userRequest.userName} onChange={onChange} isRequired={true} errorMessage="UserName is required" />
                </div>
            </div>

            {props.showFullForm &&
                <Fragment>
                    <div className="row">
                        <div className="col-12 col-sm-6">
                            <InputText name="jobTitle" placeholder="Job Title/Role" type="text" value={props.userRequest.jobTitle} onChange={onChange} isRequired={true} errorMessage="Job Title is required" />
                            <InputText name="workPhone" label="Work Phone" placeholder="Work Phone" type="text" value={props.userRequest.workPhone} onChange={onChange} />
                            <MultiSelectBox name="managementCompanyId" idField="id" valueField="name"
                                options={props.managementCompanies}
                                onChange={onManagementCompanyChange}
                                defaultValue="Select a Management Company"
                                placeholder="Select a Management Company"
                                selectedValues={props.userRequest.managementCompanyId.toString()}
                                isRequired={true}
                                errorMessage="Management Company is required"
                                isMulti={false}
                            />
                            <MultiSelectBox name="locationId" idField="id" valueField="name"
                                options={props.locations}
                                onChange={onMultiSelectChange}
                                defaultValue="Select a Location"
                                placeholder="Select a Location"
                                selectedValues={props.userRequest.locationId.toString()}
                                isRequired={true}
                                errorMessage="Requested Location is required"
                                isMulti={false}
                            />
                        </div>
                        <div className="col-12 col-sm-6">
                            <InputText name="employeeId" placeholder="Employee ID" type="text" value={props.userRequest.employeeId} onChange={onChange} isRequired={props.userRequest.isSubscriptionSSOEnabled} errorMessage="Employee ID is required" />
                            <MultiSelectBox name="countryId" idField="id" valueField="name"
                                options={props.countries}
                                onChange={onMultiSelectChange}
                                defaultValue="Select a Country"
                                placeholder="Select a Country"
                                selectedValues={props.userRequest.countryId.toString()}
                                isRequired={true}
                                errorMessage="Country is required"
                                isMulti={false}
                            />
                            <MultiSelectBox name="communityIds" idField="id" valueField="name"
                                options={props.communities}
                                selectedValues={props.userRequest.communityIds.toString()}
                                onChange={onMultiSelectChange}
                                isRequired={true}
                                placeholder="Select All Applicable Communities"
                                errorMessage="At least one Community must be selected"
                                isMulti={true}
                            />
                            <MultiSelectBox name="departmentIds" idField="id" valueField="name"
                                options={props.departments}
                                placeholder="Select Your Departments (optional)"
                                selectedValues={props.userRequest.departmentIds.toString()}
                                onChange={onMultiSelectChange}
                                isMulti={true}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <TextArea rows={2} name="additionalNotes" placeholder="Additional Notes" value={props.userRequest.additionalNotes} onChange={onChange} />
                        </div>
                    </div>                    
                </Fragment>
            }

            <div className="row">
                <div className="col-12 text-center">
                    <Button type="submit" onClick={onSubmit} bootstrapClass="outline-light" text={(props.showFullForm) ? "Submit Request" : "Continue"} />
                </div>
            </div>
        </form>
    );
}

UserProfileStep.propTypes = {
    userRequest: PropTypes.object.isRequired,
    onContinue: PropTypes.func.isRequired,
    onFormChange: PropTypes.func.isRequired,
    onEmailChange: PropTypes.func.isRequired,
    onEmailBlur: PropTypes.func.isRequired,
    isFormValid: PropTypes.bool.isRequired,
    userAccessRequestActions: PropTypes.object.isRequired,
    onManagementCompanyChange: PropTypes.func.isRequired,
    communities: PropTypes.array.isRequired,
    countries: PropTypes.array.isRequired,
    departments: PropTypes.array.isRequired,
    managementCompanies: PropTypes.array.isRequired,
    locations: PropTypes.array.isRequired,
    showFullForm: PropTypes.bool.isRequired,
    onSubmitRequest: PropTypes.func.isRequired
};

export default UserProfileStep;
